const DesktopIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M6 4.75H18C19.2426 4.75 20.25 5.75736 20.25 7V14C20.25 15.2426 19.2426 16.25 18 16.25H6C4.75736 16.25 3.75 15.2426 3.75 14V7C3.75 5.75736 4.75736 4.75 6 4.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path d="M4 13H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M8 20.0001C11.1767 18.9725 12.9298 18.9427 16 20.0001"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default DesktopIcon
